import { Component, OnInit, ChangeDetectionStrategy, Input } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Configuration } from "../../../snatch/models/configuration.model";

@Component({
  selector: 'leap-choose-variant-form',
  templateUrl: './choose-variant-form.component.html',
  styleUrls: ['./choose-variant-form.component.less']
})
export class ChooseVariantFormComponent implements OnInit {

  @Input() languages: Configuration[];
  @Input() deliveryFormats: Configuration[];
  @Input() certificateTypes: Configuration[];

  public deliveryTypeWrapper = [];
  public certificateTypeWrapper = [];

  form = this.fb.group({
    sku: null,
    variantSku: null,
    language: null,
    deliveryFormat: 'null',
    certificateType: null
  });

  constructor(private fb: FormBuilder) { }

  ngOnInit() {
    this.buildDeliveryTypeWrapper();
    this.buildCertificateTypeWrapper();
  }

  buildDeliveryTypeWrapper() {
    this.deliveryTypeWrapper = this.deliveryFormats.map((delFormat) => {
      let svgName = this.getDeliveryFormatSVG(delFormat.configKey);
      return {
        value : delFormat.configKey,
        svg : svgName,
        display : this.formatDeliveryType(delFormat.configValue),
      }
    });
  }

  buildCertificateTypeWrapper() {
    this.certificateTypeWrapper = this.certificateTypes.map((certType) => {
      let svgName = this.getCertificateTypeSVG(certType.configKey);
      return {
        value : certType.configKey,
        svg : svgName,
        display : this.formatCertificateType(certType.configValue),
      }
    });
  }

  formatCertificateType(certType: String) {
    switch (certType) {
      case 'Paper Certificate':
        return 'Paper';
        break;
      case 'Digital Certificate':
        return 'Digital';
        break;
      default:
        return certType
    }
  }

  formatDeliveryType(deliveryType: String) {
    switch (deliveryType) {
      case 'Paper Exam':
        return 'Paper';
        break;
      case 'Online Exam':
        return 'Online';
        break;
      case 'Webcam Proctor Exam':
        return 'Webcam Proctor';
        break;
      case 'AI Proctored Exam':
        return 'AI Proctor';
        break;
      default:
        return deliveryType
    }
  }

  getDeliveryFormatSVG(type: string) {
    let config = {
      'eBook' : 'deliveryFormatEbook',
      'Printed' : 'deliveryFormatPrinted',
      'Print-License' : 'deliveryFormatPrintLicense',
      'eLearning' : 'deliveryFormatElearning',
      'video' : 'deliveryFormatVideo',
      'slides' : 'deliveryFormatPresentation',
      'Online-Exam' : 'deliveryFormatOnlineExam',
      'Paper-Exam' : 'deliveryFormatPaperExam',
      'Webcam-Proctor-Online-Exam' : 'deliveryFormatWebcamProctorExam',
      'AI-Proctored-Exam' : 'deliveryFormatAIProctoredExam',
      'podcast': 'deliveryFormatVideo',
      'lab': 'deliveryFormatVideo',
      'article': 'deliveryFormatVideo',
      'paperback': 'deliveryFormatPrinted'
    };
    if (config.hasOwnProperty(type)) {
      return config[type];
    }
    return type;
  }

  getCertificateTypeSVG(type: string) {
    let config = {
      'Digital-Certificate' : 'certificateTypeDigital',
      'Paper-Certificate' : 'certificateTypePaper'
    };
    if (config.hasOwnProperty(type)) {
      return config[type];
    }
    return type;
  }
}
